<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B-2">ACKNOWLEDGMENTS</span></span></p>
<p class="FMTNI">My deepest thanks to my fellow writers of Critical Mass, whose kind wisdom taught me how to write this novel: Daniel Abraham, Yvonne Coats, Terry England, Ty Franck, Sally Gwylan, Ed Khmara, George R. R. Martin, John J. Miller, Matt Reiten, Melinda Snodgrass, Jan Stirling, Steve “S. M.” Stirling, Emily Mah “E. M.” Tippetts, Lauren Teffeau, Ian Tregillis, Sage Walker, and Walter Jon Williams.</p>
<p class="FMTX">I believe there is no other resource like you in the world. (And please forgive me if I overlooked you!)</p>
<p class="FMTX">Special thanks to my old friend Mike Weaver, who told me how Grey Angels Emerged.</p>
<p class="FMTX">To my Dinosaur Army, who helped me spread the word.</p>
<p class="FMTX">And to Wanda Day, who crocheted me a Triceratops head. And for whom Rob’s axe is decidedly not named.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?88b5aaa4